//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Scheme",1,0],[1,"SelectedFeatureGroupList",0,"Features.SelectFeatureList",0],[0,"TypeOptionMenu",1,0]],[[[],"AnalyzePart",{},0,0]],[]];
SPLM.GeometricUtilities.ConvertFeatureGroupsToDesignGroupsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.ConvertFeatureGroupsToDesignGroupsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.ConvertFeatureGroupsToDesignGroupsBuilder.TypeOptionsMenu = Object.freeze({
    "SingleFeatureGroup" : "SingleFeatureGroup", "AllFeatureGroups" : "AllFeatureGroups"});

SPLM.GeometricUtilities.ConvertFeatureGroupsToDesignGroupsBuilder.ConversionScheme = Object.freeze({
    "Convert" : "Convert", "EmbedDesignGroupInFeatureGroup" : "EmbedDesignGroupInFeatureGroup", "EmbedFeatureGroupInDesignGroup" : "EmbedFeatureGroupInDesignGroup"});

export default SPLM;